export default __webpack_public_path__ + "static/media/Yash_Img.a2f90db6.svg";